// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"c49c3e4e","188":"8b73f075","300":"c3b03f59","403":"4dc35e89","608":"d7b2dbd7","766":"f818591f","802":"c5b9b3b9","876":"083c1ea7","877":"0c1797ca"}[chunkId] + ".chunk.js";
};